// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3zxBH","row":"ProcedureTreatmentSummary_row__1Ondi"};